import { useEffect } from "react";
import { useCategories } from "@/hooks/categories";
import { initialCategories } from "@/config/initialData";

export function InitialDataProvider({ children }: { children: React.ReactNode }) {
  const { categories, setCategories } = useCategories();

  useEffect(() => {
    // Inicializa as categorias apenas se não houver nenhuma
    if (categories.length === 0) {
      setCategories(initialCategories);
    }
  }, [categories.length, setCategories]);

  return <>{children}</>;
}
